<toaster-container [toasterconfig]="toasterconfig"></toaster-container>
<div class="col-sm-6 col-xs-10 col-lg-3 center-div">
    <div class="panel panel-default">
        <div class="panel-heading">Please enter your new password.</div>
        <div class="panel-body">
            <form name="changePasswordForm" #ChangePasswordForm="ngForm" class="form-validate" (submit)="submitForm()" novalidate="">
                <div class="form-group">
                    <div class="input-group">
                        <span class="input-group-addon"><i class="fa fa-lock"></i></span>
                        <input class="form-control" type="password" name="password" #password placeholder="Password" [(ngModel)]="model.password" required/>
                    </div>
                </div>
                <div class="form-group" style="margin-bottom: 50px;">
                    <div class="input-group">
                        <span class="input-group-addon"><i class="fa fa-lock"></i></span>
                        <input class="form-control" type="password" name="confirm_password" #confirmPassword placeholder="Confirm Password" [(ngModel)]="model.confirm_password" required/>
                    </div>
                </div>
                <button *ngIf="!isSaving" class="btn btn-sm btn-default button-style" type="submit" [disabled]="!ChangePasswordForm.form.valid">Reset Password</button>
                <div *ngIf="isSaving" class="panel-footer text-center">
                    <div class="whirl standard"></div>
                </div>
            </form>
        </div>
    </div>
</div>
